import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-white">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#4CAF50]/10 mb-6">
          <i className="ri-map-pin-off-line text-[#4CAF50] text-2xl" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-[#1A2B4A] mb-3">
          Sayfa Bulunamadı
        </h1>
        <p className="text-[#718096] text-base mb-8 max-w-sm">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 bg-[#4CAF50] text-white font-semibold px-7 py-3 rounded-full hover:bg-[#388E3C] transition-colors duration-200 cursor-pointer"
        >
          <i className="ri-home-line" />
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
}
